import { render, staticRenderFns } from "./ObjectFields.vue?vue&type=template&id=40a90766&scoped=true&"
import script from "./ObjectFields.vue?vue&type=script&lang=js&"
export * from "./ObjectFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a90766",
  null
  
)

export default component.exports